/*
 * Copyright © 2023 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import trackerConfig from './config/trackerConfig';
import SentryLogTracker from './trackers/SentryLogTracker';
import Log from './model/Log';

class LogTracker {
  static tracker = null;

  static init() {
    const enabledIntegrations = Object.values(trackerConfig.integrations)?.filter(i => i.enabled);
    if (enabledIntegrations?.length === 0) {
      return;
    }
    this.tracker = new SentryLogTracker();
  }

  static captureException(exception) {
    return this.tracker && this.tracker.captureException(exception);
  }

  static log(data, logLevel) {
    if (!this.tracker) {
      return false;
    }
    if (typeof data === 'string') {
      const breadcrumb = new Log.Builder().setLevel(logLevel).setMessage(data);
      return this.tracker.log(breadcrumb);
    }
    return this.tracker.log(data);
  }

  static tag(key, value) {
    return this.tracker && this.tracker.setTag(key, value);
  }
}
export default LogTracker;
